import { Box, Button } from "@mui/material";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const VendorList = () => {
  const [vendors, setVendors] = useState([]);

  const orgId = JSON.parse(localStorage.getItem("org"));
  const storedUser = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate();

  useEffect(() => {
    const getVendors = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-list/org?orgId=${orgId}`,
          {
            headers: {
              Authorization: `Bearer ${storedUser.accessToken}`,
            },
          }
        );

        setVendors(res.data);
      } catch (error) {
        console.log(
          error.response?.data?.Exception || "Access denied"
        );
      }
    };

    getVendors();
  }, []);

  const columns = [
    {
      field: "code",
      headerName: "Vendor Code",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Vendor Name",
      flex: 1,
    },
    {
      field: "gst",
      headerName: "GST",
      flex: 1,
    },
    {
      field: "pan",
      headerName: "PAN",
      flex: 1,
    },
    storedUser.userRole.includes("ADMIN") &&
    {
      field: "action",
      headerName: "Action",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Button
          className="btn-outlined"
          sx={{
            margin: "0 !important",
            padding: "4px 12px !important",
            width: "auto !important",
          }}
          onClick={() =>
            navigate(`/approval/admin/add-vendor/${params.row.code}`)
          }
        >
          Edit
        </Button>
      ),
    },
  ];

  const rows = vendors ? vendors : [];

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Link to={storedUser.userRole.includes("ADMIN") ? `/approval/admin/add-vendor` : '/approval/dashboard/add-vendor'}>
          <Button className="btn-contained">
            + Add Vendor
          </Button>
        </Link>
      </div>

      <div className="dashboard-container">
        <h1>List of Vendors</h1>

        <Box sx={{ background: "#fff" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20]}
            disableRowSelectionOnClick
            disableColumnSelector
            disableDensitySelector
            slots={{
              toolbar: CustomToolbar,
            }}
            getRowId={(row) => row.id}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "even"
                : "odd"
            }
            sx={{
              position: "relative",
              border: "none",
              fontFamily: "Inter !important",

              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "700 !important",
              },

              "& .MuiDataGrid-columnHeaders": {
                background: "none !important",
                color: "black",
                fontSize: "14px",
                borderRadius: "10px",
              },

              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#fff",
              },

              "& .MuiDataGrid-cell": {
                fontSize: "13px",
                border: "none",
              },

              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },

              "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
                color: "#000 !important",
                border: "1px solid #B0B0B0",
                borderRadius: "12px",
                padding: 1,
              },

              "& .MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },

              "& .MuiInputBase-root-MuiInput-root": {
                borderBottom: "none !important",
              },

              [`& .${gridClasses.row}.even`]: {
                backgroundColor: "#EAF4FF",
              },

              "& .MuiInput-underline:before": {
                borderBottom: "none !important",
              },

              "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
            }}
          />
        </Box>
      </div>
    </div>
  );
};

export default VendorList;

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{
        display: "flex",
        justifyContent: "end",
      }}
    >
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",

          "&:hover": {
            backgroundColor: "#D8E9F0",
          },

          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },

          width: 300,
        }}
      />
    </GridToolbarContainer>
  );
}